<ng-select
  [labelForId]="labelForId"
  class="select"
  [items]="countries"
  bindLabel="label"
  bindValue="country_code"
  [clearable]="false"
  [(ngModel)]="selectedCountryCode"
  (change)="countryChanged()"
  aria-label="Choose your country"
>
</ng-select>

<select
  class="select--mobile"
  [(ngModel)]="selectedCountryCode"
  (change)="countryChanged()"
>
  <option>{{ content?.fields?.testIntroChoose }}</option>
  <option *ngFor="let country of countries" [value]="country.country_code">
    {{ country.label }}
  </option>
</select>
